import ProcessedResults from './ProcessedResults';

export default ProcessedResults;
